export const AVATAR_TEXT_TYPE = {
    initials: 'initials',
    plain: 'plain',
};
//# sourceMappingURL=constants.js.map